const figmaWidth = 1280
const figmaHeight = 900

export function normalizeWidth(sizePx: number) {
  const vwValue = window.outerWidth/100
  const newWidth = ((sizePx / figmaWidth) * window.outerWidth);
  return `${newWidth/vwValue}vw`
}

export function normalizeHeight(sizePx: number) {
  const vwValue = window.outerHeight/100
  const newHeight = ((sizePx / figmaHeight) * window.outerHeight);
  return `${newHeight/vwValue}vh`
}

export function newNormalizeHeight(sizePx: number) {
  const newHeight = ((sizePx / figmaHeight) * window.innerHeight);
  return newHeight
}

export function newNormalizeWidth(sizePx: number) {
  const newWidth = ((sizePx / figmaWidth) * window.innerWidth);
  return newWidth
}

export function normalizeHeightToVH(sizePx: number) {
  const newHeightVH = ((sizePx / figmaHeight) * 100) + 'vh';
  return newHeightVH;
}

export function normalizeWidthToVW(sizePx: number) {
  const newWidthVW = ((sizePx / figmaWidth) * 100) + 'vw';
  return newWidthVW;
}